import { createContext, useCallback, useContext } from "react";
import { ChartTheme } from "../theme/chartColors";

interface ChartThemeContextType {
  theme: ChartTheme;
  setTheme: (theme: ChartTheme) => void;
}

export const ChartThemeContext = createContext<ChartThemeContextType>({
  theme: "colorful",
  setTheme: () => {},
});

export function useChartTheme() {
  const data = useContext(ChartThemeContext);

  const getTheme = useCallback((index: number) => {
    return data.theme === "colorful" ? `var(--chart-colorful-${String(index)})` : `var(--chart-mono-${String(index)})`;
  }, [data.theme]);

  const getMonotheme = (index: number) => `var(--chart-mono-${String(index)})`

  return {
    ...data,
    getTheme,
    getMonotheme
  }
}
